function compareArrayOfObjects(arr, newArr, id) {
    var created = [];
    var updated = [];
    var deleted = [];
    var _loop_1 = function (e) {
        var elem = arr.find(function (el) { return el[id] === e[id]; });
        if (elem) {
            for (var key in elem) {
                if (elem[key] !== e[key]) {
                    updated.push(e);
                    break;
                }
            }
        }
        else {
            created.push(e);
        }
    };
    for (var _i = 0, newArr_1 = newArr; _i < newArr_1.length; _i++) {
        var e = newArr_1[_i];
        _loop_1(e);
    }
    var _loop_2 = function (e) {
        var elem = newArr.find(function (el) { return el[id] === e[id]; });
        if (!elem) {
            deleted.push(e);
        }
    };
    for (var _a = 0, arr_1 = arr; _a < arr_1.length; _a++) {
        var e = arr_1[_a];
        _loop_2(e);
    }
    return {
        create: created,
        update: updated,
        delete: deleted,
    };
}
export default compareArrayOfObjects;
//# sourceMappingURL=compareArrayOfObjects.js.map